import React from "react";
import logo from "../img/meal-logo.png";

export default function Nav() {
	return (
		<nav>
			<img src={logo} alt="#" className="logo" />
			<p>Lunch Ideas</p>
		</nav>
	);
}
